export const HIDDEN = 'hidden'
